import React from "react";
import "./pay.css";
function Confirmpayment() {
  return (
    // <div className='Confirmpay-card '>
    <div className="Confirmpay-card-div ">
      <div className="c-p-header-cont ">
        <div className="c-p-header-svg w-100 ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="84"
            height="60"
            viewBox="0 0 84 84"
            fill="none"
          >
            <path
              d="M21.6078 52.1628C21.228 51.7931 20.6214 51.7891 20.2366 52.1567L17.4131 54.8495L16.5482 53.8257C16.1917 53.4013 15.5557 53.3558 15.1395 53.7224C14.7303 54.088 14.6939 54.7138 15.0615 55.123C15.5668 55.6871 16.2515 56.4436 16.689 56.9013C17.2399 57.4786 17.9184 57.5221 18.4825 56.9844C19.401 56.1053 20.9039 54.6156 21.7881 53.7386C22.1769 53.3487 22.1729 52.7167 21.7789 52.3319L21.6078 52.1628Z"
              fill="#D99D2B"
            />
            <path
              d="M34.1341 49.0507H50.9596C51.3252 49.0507 51.625 48.755 51.625 48.3853C51.625 48.0197 51.3252 47.72 50.9596 47.72H34.1341C33.7685 47.72 33.4688 48.0197 33.4688 48.3853C33.4688 48.755 33.7685 49.0507 34.1341 49.0507Z"
              fill="#D99D2B"
            />
            <path
              d="M34.1341 52.34H48.8451C49.2147 52.34 49.5094 52.0382 49.5094 51.6736C49.5094 51.306 49.2147 51.0082 48.8451 51.0082H34.1341C33.7685 51.0082 33.4688 51.306 33.4688 51.6736C33.4688 52.0382 33.7685 52.34 34.1341 52.34Z"
              fill="#D99D2B"
            />
            <path
              d="M69.9676 48.2475L58.229 51.9663V39.215C58.229 36.3388 55.8906 33.9984 53.0114 33.9984H27.6395L62.0004 23.1085C63.5033 22.6315 65.1065 23.463 65.5835 24.9659L71.827 44.6665C72.3009 46.1674 71.4705 47.7705 69.9676 48.2475ZM56.1003 58.465C56.1003 59.8788 54.9549 61.0221 53.5431 61.0221H32.2747C30.1551 61.0221 28.0375 61.0272 25.9178 61.0272H24.0514C25.8317 59.4676 26.9609 57.1748 26.9609 54.6217C26.9609 49.9256 23.1419 46.1036 18.4408 46.1036C15.8877 46.1036 13.5949 47.2308 12.0404 49.0111V42.317H56.1003V58.465ZM18.4408 61.0221C14.9074 61.0221 12.0424 58.1571 12.0424 54.6217C12.0424 51.0893 14.9074 48.2232 18.4408 48.2232C21.9753 48.2232 24.8413 51.0893 24.8413 54.6217C24.8413 58.1571 21.9753 61.0221 18.4408 61.0221ZM12.0424 38.6884C12.0424 37.2746 13.1858 36.1312 14.5995 36.1312H53.5411C54.9549 36.1312 56.1003 37.2746 56.1003 38.6884V40.1994H12.0424V38.6884ZM42 0C18.8449 0 0 18.8388 0 42C0 65.1612 18.8449 84 42 84C65.1571 84 84 65.1612 84 42C84 18.8388 65.1571 0 42 0Z"
              fill="#D99D2B"
            />
            <path
              d="M34.1341 55.6232H46.1076C46.4753 55.6232 46.773 55.3265 46.773 54.9589C46.773 54.5933 46.4753 54.2935 46.1076 54.2935H34.1341C33.7685 54.2935 33.4688 54.5933 33.4688 54.9589C33.4688 55.3265 33.7685 55.6232 34.1341 55.6232Z"
              fill="#D99D2B"
            />
          </svg>
        </div>

        <div className="c-p-header">
          <p className="c-p-header-par ">Confirm payment</p>
        </div>
        <div className="c-p-header ">
          <p className="c-p-header-par2  mb-0">11493 SAR</p>
        </div>
      </div>
      <div className="c-data-div  w-100">
        <p className="c-p-par1">Asweerun Contemporary Sports Men's Shoes </p>
      </div>

      <button className="  Confirmpay-btn ">
        <a
          className="Confirmpay-btn-par"
          style={{ textDecoration: "none" }}
          data-bs-toggle="modal"
          href="#confpay2"
        >
          {" "}
          Confirm Payment
        </a>
      </button>
    </div>
  );
}

export default Confirmpayment;
